module.exports = __webpack_public_path__ + "img/师资培训.99a9a477.jpg";